import S from "./index.module.scss";
import { CULTURES } from "@/views/culture/constants/cultures";
import CultureBlock from "@/views/culture/components/cultures-list/culture-block";

const CulturesList = () => {

  return (
    <div className={S.listWrapper}>
      {CULTURES.map((culture, index) => (
        <CultureBlock key={index} block={culture} />
      ))}
    </div>
  )
};

export default CulturesList;